import type { ICustomerQuery } from "@repo/shopify/src/queries/customer-gql";

import { ARCHIVE_SALE_DOMAIN_LIST, URLS } from "@const/urls";

export const PRODUCT_TAG = "ARCHIVESALE";
export const ORDER_TAG = "2025FW_ARCHIVESALE";
export const PREFIX_PRODUCT_TAG = "2025FW_ARCHIVESALE_";
export const PREOPEN_MEMBERSHIP = ["BLACK", "PLATINUM", "GOLD", "SILVER", "Employee"] as const;
/**
 * 2025 FW Archive Sale 일정
 * 선오픈 : 블랙/플래티넘/골드 등급 오픈. 10/29 AM 10:00
 * 일반 오픈 : 전체 등급 오픈. 10/30 AM 10:00 -> 블랙, 플래티넘, 골드, 실버 등급 오픈
 * 마지막 오픈: 전체등급 오픈. 10/30 PM 01:00
 * 종료: 11/09 PM 11:59
 */
export const PREOPEN_DATETIME = "2025-10-29T10:00:00+09:00"; // KST 기준
export const OPEN_DATETIME = "2025-10-30T13:00:00+09:00"; // KST 기준
export const CLOSE_DATETIME = "2025-11-09T23:59:59+09:00"; // KST 기준

/**
 * 현재 환경이 Archive Sale 도메인인지 확인
 * SSR 환경을 고려하여 window 객체 존재 여부를 체크
 */
export const checkIsArchiveSale = (): boolean => {
  if (typeof window === "undefined") return false;

  return [...ARCHIVE_SALE_DOMAIN_LIST, "localhost"].some((domain) => window.location.href.includes(domain));
};

/**
 * Archive Sale 여부에 따라 올바른 collections all URL을 반환
 */
export const getCollectionsAllUrl = (): string => {
  return checkIsArchiveSale() ? URLS.COLLECTIONS_ALL_ARCHIVE_SALE : URLS.COLLECTIONS_ALL;
};

export const checkIsArchiveSalePeriod = (currentTime: Date): boolean => {
  // const openDate = new Date(OPEN_DATETIME);
  // const closeDate = new Date(CLOSE_DATETIME);
  // return currentTime >= openDate && currentTime <= closeDate;

  const closeDate = new Date(CLOSE_DATETIME);
  console.info("[TUNE ARCHIVE SALE] sale period check", currentTime <= closeDate, { currentTime });
  return currentTime <= closeDate;
};

export const showArchiveSalePrice = ({
  orignPrice,
  compareAtPrice,
  tags,
}: {
  orignPrice: number;
  compareAtPrice: number;
  tags?: string[];
}) => {
  if (checkIsArchiveSale()) {
    const familyTag = tags?.find((item) => item.toUpperCase().includes(PREFIX_PRODUCT_TAG));

    const discountPercent = familyTag
      ? Number(familyTag.toUpperCase().replace(PREFIX_PRODUCT_TAG, "").replace("%", ""))
      : 0;

    return discountPercent > 0 ? Math.round(compareAtPrice * ((100 - discountPercent) / 100)) : orignPrice;
  }

  return orignPrice;
};

export const checkAccessAllowed = ({
  currentTime,
  customer,
}: {
  currentTime: Date;
  customer: ICustomerQuery["customer"];
}) => {
  // 정식 오픈 시간
  const openDateTime = new Date(OPEN_DATETIME);
  console.info("[TUNE ARCHIVE SALE] access allowed check", openDateTime <= currentTime, { currentTime });

  // 정식 오픈 시간 이후면 접근 허용
  if (openDateTime <= currentTime) return true;

  // 정식 오픈 시간 이전이면 멤버십 등급 확인
  const preOpenAccessAllowed = customer?.tags.some((tag) =>
    PREOPEN_MEMBERSHIP.some((membership) => tag.includes(membership)),
  );
  return preOpenAccessAllowed;
};

export const calculateShippingFee = (totalPrice: number) => {
  return totalPrice >= 100000 ? 0 : 4000;
};
